<template>
    <div>
        <p>Mise à jour des produits</p>
        <el-button type="primary" icon="fas fa-sync" @click="syncCatalogueAllnet" circle></el-button>
    </div>
</template>

<script>
import script from "../../../script/script_allnet.js"
export default {
  created () {
  },
  methods: {
    syncCatalogueAllnet: script.syncCatalogueAllnet,
  },
  watch: {
  },
  data () {
    return {
    }
  },

}
</script>

<style>

</style>